import { formatCurrency } from '@/utils/general/index'


export const buildWowAttrs = (itineraryData: any = {}) => {
    const {
        SEARCH_DETAILS: { sectorType = '' } = {},
        WOW = {},
        ADDITIONAL_OFFER_CALLOUT
    } = itineraryData || {}
    const { wowPrice, wowSavings, coupon = {}, supercoin = {}, wallet = {}, cbc = {} } = WOW || {}
    const isDom = sectorType === 'DOM'

    const stripData = ADDITIONAL_OFFER_CALLOUT?.callouts?.[0]
    const calloutText = stripData?.strip
        ? stripData.strip
              .replace('{savedAmount}', formatCurrency(stripData?.savedAmount || 0))
              .replace('{cbcAmount}', formatCurrency(stripData?.cbcAmount || 0))
              .replace('{subtitle}', stripData?.subtitle || '')
        : ''

    return {
        a_trip_type: isDom ? 'domestic' : 'international',
        a_wow_amount: (isDom ? wowSavings ?? wowPrice : wowPrice ?? wowSavings) ?? 'N/A',
        a_wow_callout: calloutText || 'N/A',
        a_wow_cashback: cbc?.cashback ?? 'N/A',
        cbc_bank: cbc?.cardName || 'N/A',
        is_cbcc_user: !!cbc?.cashback,
        ct_coupon_applied: coupon?.couponCode || 'N/A',
        ct_coupon_discount: coupon?.discount ?? 'N/A',
        supercoin_balance: supercoin?.redeemableSupercoinAmount ?? 'N/A',
        ct_wallet_balance: wallet?.redeemableBalance ?? 'N/A'
    }
}

export const getSrpWalletBalance = (wowFare: any = {}) => {
    const { walletBalance } = wowFare?.metaData || {}
    return walletBalance ?? 0
}

/**
 * Confirmation-page WoW attribute block. Confirmation data exposes WoW values
 * under `data.savings` ({ totalSavings, cashback, message }) rather than the
 * itinerary `WOW` node, so it is built separately.
 */
export const buildWowConfirmationAttrs = (data: any = {}) => {
    const { savings, couponDetails } = data || {}

    return {
        a_wow_amount: savings?.totalSavings ?? 'N/A',
        a_wow_cashback: savings?.cashback ?? 'N/A',
        a_wow_callout: savings?.message || 'N/A',
        ct_coupon_applied: couponDetails?.couponCode || 'N/A'
    }
}
